





















































































































































































































































































































































































































































































































































































































































































































import { Component, Mixins } from "vue-property-decorator";
import swal from "sweetalert";
import Api from "@/api";

import FormErrorsMixin from "@/mixins/FormErrors";
import ViewLoader from "@/components/Common/ViewLoader.vue";
import AlertBox from "@/components/Common/Alerts/AlertBox.vue";
import TextInput from "@/components/Common/Inputs/TextInput.vue";
import InfoButton from "@/components/Common/Buttons/InfoButton.vue";
import BackButton from "@/components/Common/Buttons/BackButton.vue";
import DangerButton from "@/components/Common/Buttons/DangerButton.vue";
import OrganizationActions from "@/components/Settings/Organizations/OrganizationActions.vue";
import Error404 from "@/components/Common/Error404.vue";
import { ICountry, ICountryState, ICustomer, IOrganization } from "@/interface";
import { AxiosResponse } from "axios";

Component.registerHooks(["beforeRouteEnter", "beforeRouteUpdate"]);

@Component({
  components: {
    ViewLoader,
    AlertBox,
    TextInput,
    InfoButton,
    BackButton,
    DangerButton,
    OrganizationActions,
    Error404
  }
})
export default class Organization extends Mixins(FormErrorsMixin) {
  public loading = false;
  public updating = false;
  public validatedInputs = [
    "name",
    "type",
    "email",
    "founding_year",
    "internal_note",
    "website",
    "uid",
    "dvr",
    "zvr",
    "phone_number.prefix",
    "phone_number.number",
    "fax_number.prefix",
    "fax_number.number",
    "address.country_id",
    "address.state_id",
    "address.city",
    "address.post_code",
    "address.street_name",
    "address.street_number",
    "address.additional_information"
  ];
  private noDataExist = false;
  private countries: Array<ICountry> = [];
  private selectedCountry: ICountry = {
    states: null
  };
  private originalName: string | null = null;
  private selectedOrganization: IOrganization = {
    name: null,
    type: null,
    email: null,
    founding_year: null,
    internal_note: null,
    website: null,
    uid: null,
    dvr: null,
    zvr: null,
    phone_number: {
      prefix: null,
      number: null
    },
    fax_number: {
      prefix: null,
      number: null
    },
    address: {
      country_id: null,
      state_id: null,
      city: null,
      post_code: null,
      street_name: null,
      street_number: null,
      additional_information: null
    }
  };
  private selectedOrganizationId: string | null = null;
  private organizationTypes: Array<string> = [];
  private failedRequest = false;
  // customers data
  private customers: Array<ICustomer> = [];
  private customersLength = 0;
  private currentPage = 1;
  private total = 0;
  private from = 0;
  private to = 0;
  private firstPage = 1;
  private lastPage: number | null = null;
  private perPage: number | null = null;
  private searchFilter = "";

  private beforeRouteEnter(to: any, from: any, next: any): void {
    next((vm: this) => {
      vm.getOrganizationTypes();
      vm.getCountries();
      vm.selectedOrganizationId = vm.$route.params.organization_id;
      if (
        typeof vm.selectedOrganizationId !== "undefined" &&
        vm.selectedOrganizationId !== null
      ) {
        if (vm.$route.query.organization_created === "true") {
          swal("Success!", "The organization was created.", "success").then(
            () => {
              window.history.pushState(
                {},
                document.title,
                window.location.pathname
              );
            }
          );
        }
        vm.getOrganization(() => {
          //
        });
        vm.getOrganizationCustomers();
      }
    });
  }

  private beforeRouteUpdate(to: any, from: any, next: any): void {
    this.getOrganizationTypes();
    this.getCountries();
    if (
      typeof this.selectedOrganizationId !== "undefined" &&
      this.selectedOrganizationId !== null
    ) {
      this.getOrganization(() => {
        //
      });
      this.getOrganizationCustomers();
    }
    next();
  }

  private createOrUpdateOrganization(): void {
    if (this.selectedOrganizationId == null) {
      this.createOrganization();
    } else {
      this.updateOrganization();
    }
  }

  private getOrganizationTypes(): void {
    const endpoint = this.$partnerEndpoint("organizations/types");

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.organizationTypes = response.data;
      })
      .catch((error: any) => {
        console.log(error.response);
      });
  }

  private createOrganization(): void {
    if (this.updating) {
      return;
    }

    this.resetErrors();
    this.updating = true;
    const endpoint: string = this.$partnerEndpoint("organizations");

    Api()
      .post(endpoint, this.selectedOrganization)
      .then((response: AxiosResponse) => {
        this.selectedOrganizationId = response.data.data.id;
        this.$router.push({
          name: "OrganizationDetails",
          params: { organization_id: `${this.selectedOrganizationId}` },
          query: { organization_created: "true" }
        });
        this.$scrollTo("#organization-name", 500);
      })
      .catch((error: any) => {
        this.storeErrors(error.response.data.errors);
        this.$scrollTo("#organization-name", 500);
      })
      .finally(() => {
        this.updating = false;
      });
  }

  private getOrganization(successCallback?: any): void {
    if (this.loading) {
      return;
    }

    this.resetErrors();
    this.loading = true;
    const endpoint: string = this.$partnerEndpoint(
      "organizations/" + this.selectedOrganizationId
    );

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.selectedOrganization = response.data.data;
        if (this.selectedOrganization.name) {
          this.originalName = this.selectedOrganization.name;
        }
        if (
          this.selectedOrganization.address !== undefined &&
          this.selectedOrganization.address.country_id
        ) {
          this.setSelectedCountry(this.selectedOrganization.address.country_id);
        }
        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .catch((error: any) => {
        if (error.response.status === 404) {
          this.noDataExist = true;
        }
        console.log(error.response);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private updateOrganization(): void {
    if (this.loading || this.updating) {
      return;
    }

    this.resetErrors();
    this.updating = true;
    const endpoint: string = this.$partnerEndpoint(
      "organizations/" + this.selectedOrganizationId
    );

    Api()
      .put(endpoint, this.selectedOrganization)
      .then(() => {
        this.getOrganization(() => {
          //
        });
        swal({
          title: "Success!",
          text: "The organization was updated.",
          icon: "success"
        });
      })
      .catch((error: any) => {
        this.storeErrors(error.response.data.errors);
        this.$scrollTo("#organization-name", 500);
      })
      .finally(() => {
        this.updating = false;
      });
  }

  private deleteOrganization(): void {
    if (this.loading || this.updating) {
      return;
    }

    swal({
      title: "Are you sure?",
      text: "The organization will be deleted",
      icon: "warning",
      dangerMode: true,
      buttons: {
        cancel: {
          visible: true,
          text: "Cancel",
          closeModal: true
        },
        confirm: {
          visible: true,
          text: "Yes, delete it!",
          closeModal: true
        }
      }
    }).then(isConfirm => {
      if (isConfirm) {
        const endpoint: string = this.$partnerEndpoint(
          "organizations/" + this.selectedOrganizationId
        );

        Api()
          .delete(endpoint)
          .then(() => {
            this.$router.push({
              name: "OrganizationsOverview",
              query: { organization_deleted: "true" }
            });
          })
          .catch((error: any) => {
            console.log(error.response);
            if (error.response.status === 403) {
              swal({
                title: "Missing permission",
                text: "You are not allowed to delete organizations.",
                icon: "error"
                //dangerMode: true,
              });
            }
          });
      } else {
        //
      }
    });
  }

  private getOrganizationCustomers(successCallback?: any): void {
    this.customers = [];
    const endpoint: string = this.$partnerEndpoint(
      "organizations/" + this.selectedOrganizationId + "/customers"
    );

    Api()
      .get(endpoint, {
        params: { page: this.currentPage, search: this.searchFilter }
      })
      .then((response: AxiosResponse) => {
        this.customers = response.data.data;
        this.currentPage = response.data.meta.current_page;
        this.total = response.data.meta.total;
        this.from = response.data.meta.from;
        this.to = response.data.meta.to;
        this.lastPage = response.data.meta.last_page;
        this.perPage = response.data.meta.per_page;
        this.customersLength = this.customers.length;
        this.failedRequest = false;
        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .catch(() => {
        this.failedRequest = true;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private organizationTypeShouldBeSelected(organizationType: string): boolean {
    return this.selectedOrganization.type == organizationType;
  }

  private getCountries(successCallback?: any): void {
    Api()
      .get("api/internal/v1/countries")
      .then((response: AxiosResponse) => {
        this.countries = response.data.data;
        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .catch((error: any) => {
        console.log(error);
      });
  }

  private countryShouldBeSelected(country: ICountry): boolean {
    return (
      this.selectedOrganization !== null &&
      this.selectedOrganization.address !== undefined &&
      this.selectedOrganization.address.country_id == country.id
    );
  }

  private stateShouldBeSelected(state: ICountryState): boolean {
    return (
      this.selectedOrganization !== null &&
      this.selectedOrganization.address !== undefined &&
      this.selectedOrganization.address.state_id == state.id
    );
  }

  private setSelectedCountry(countryId: number): void {
    for (let i = 0; i < this.countries.length; i++) {
      if (countryId == this.countries[i].id) {
        this.selectedCountry = this.countries[i];
      }
    }
  }

  private onChangeSelectedCountry(event: any): void {
    for (let i = 0; i < this.countries.length; i++) {
      if (event.target.value == this.countries[i].id) {
        this.selectedCountry = this.countries[i];
      }
    }
  }

  private goToFirstPage(): void {
    if (!this.disabledFirstPage) {
      this.currentPage = 1;
      this.getOrganizationCustomers(() => {
        //
      });
    }
  }

  private goToPreviousPage(): void {
    if (!this.disabledPreviousPage) {
      this.currentPage--;
      this.getOrganizationCustomers(() => {
        //
      });
    }
  }

  private goToNextPage(): void {
    if (!this.disabledNextPage) {
      this.currentPage++;
      this.getOrganizationCustomers(() => {
        //
      });
    }
  }

  private goToLastPage(): void {
    if (!this.disabledLastPage) {
      if (this.lastPage) {
        this.currentPage = this.lastPage;
      }
      this.getOrganizationCustomers(() => {
        //
      });
    }
  }

  get disabledFirstPage(): boolean {
    return this.currentPage === 1;
  }

  get disabledPreviousPage(): boolean {
    return this.currentPage === 1;
  }

  get disabledNextPage(): boolean {
    return this.currentPage === this.lastPage;
  }

  get disabledLastPage(): boolean {
    return this.currentPage === this.lastPage;
  }
}
